import React from 'react';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

const ArrowContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  position: absolute;
  left: ${({ left }) => (left ? left : '24px')};
  top: ${({ top }) => (top ? top : '24px')};
`;

function ArrowBack(props) {
  const { text, left, top, history } = props;

  const handleBack = () => {
    history.goBack();
  };

  return (
    <ArrowContainer onClick={handleBack} left={left} top={top}>
      <div className="flexContainer--center">
        <img src="/img/0-icons-blue-arrow-back.svg" alt="logo" />
        <Typography
          color="primary"
          style={{
            fontSize: 14,
            lineHeight: 1,
            paddingBottom: 4,
            marginLeft: 8
          }}
        >
          {text}
        </Typography>
      </div>
    </ArrowContainer>
  );
}

export default withRouter(ArrowBack);
